/**
 * Recettes d'hier et d'aujourd'hui — Landing page interactions
 */
(function () {
  'use strict';

  /* Scroll reveal */
  var revealEls = document.querySelectorAll('.rl-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* FAQ accordion */
  document.querySelectorAll('.rl-faq__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.rl-faq__item');
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.rl-faq__item.is-open').forEach(function (open) {
        open.classList.remove('is-open');
        open.querySelector('.rl-faq__question').setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* Smooth scroll for in-page anchor links only (not product links) */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var id = link.getAttribute('href');
      if (!id || id === '#') {
        e.preventDefault();
        return;
      }
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* Header shadow on scroll */
  var header = document.querySelector('.rl-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 20
        ? '0 4px 24px rgba(43, 31, 20, 0.08)'
        : 'none';
    }, { passive: true });
  }
})();
